import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as libraryActions from '~/library/actions';
import LibraryViewVersionLicenseRow from '~/library/components/LibraryViewVersionLicenseRow';
type LibraryViewVersionLicensesProps = {
  libraryState: object;
  actions: object;
};
class LibraryViewVersionLicenses extends React.Component<LibraryViewVersionLicensesProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    const { libraryState } = this.props;
    const { component, version, isLoadingLicenses } = libraryState;
    if (!_.isEmpty(component) && !isLoadingLicenses) {
      this.props.actions.getLicenses(version);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { libraryState } = nextProps;
    const { component, version, isLoadingLicenses, licenses = [] } = libraryState;
    const activeVersion = this.getActiveVersion(version, component);
    const licenseInfoModels = activeVersion.licenseInfoModels || [];
    const licensesArr = licenses || [];
    // Do a getLicenses -only- when there's licenseInfoModels available and licenses have not been retrieved yet
    if (
      !_.isEmpty(component) &&
      !isLoadingLicenses &&
      licenseInfoModels.length > 0 &&
      !licensesArr.length
    ) {
      this.props.actions.getLicenses(version);
    }
  }
  getActiveVersion(version, component) {
    const { libraryModel = {} } = component;
    const { versions = [] } = libraryModel;
    const activeVersion =
      _.find(versions, release => {
        return release.version === version;
      }) || {};
    return activeVersion;
  }
  render() {
    const { libraryState } = this.props;
    const { component = {}, version = '' } = libraryState;
    const { libraryModel = {} } = component;
    const { versions = [] } = libraryModel;
    const activeVersion =
      _.find(versions, release => {
        return release.version === version;
      }) || {};
    const licenseInfoModels = activeVersion.licenseInfoModels || [];
    let licenseElements = [];
    licenseInfoModels.forEach(infoModel => {
      licenseElements.push(
        <LibraryViewVersionLicenseRow
          infoModel={infoModel}
          key={infoModel.name}
          isExpanded={false}
        />
      );
    });
    if (!licenseInfoModels.length) {
      licenseElements = <div>No licenses found for version {activeVersion.version}</div>;
    }
    return (
      <div className="grid">
        <div className="grid__item col-1-1">{licenseElements}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { libraryState: state.libraryState };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewVersionLicenses);
